import { useSelector } from 'react-redux';

import { getItemUid } from 'entities/CatalogItem/lib/getItemUid';
import { getSelectedCatalogItems } from 'entities/CatalogItem/model/selectors/catalogItemSelectors';
import { CatalogItem } from 'entities/CatalogItem/model/types/CatalogItemSchema';
import { useCatalogIdentity } from 'shared/lib/contexts/CatalogIdentityContext';
import { has } from 'shared/lib/lodash/lodash';

interface UseGetItemDataUpdateProps {
    item: CatalogItem;
}

export const useGetItemDataUpdate = ({ item }: UseGetItemDataUpdateProps) => {
    const selectedItems = useSelector(getSelectedCatalogItems);
    const catalogIdentity = useCatalogIdentity();
    const selectionKey = getItemUid(item, catalogIdentity);

    const qty = selectedItems?.[selectionKey]?.qty;
    const isActive = has(selectedItems, selectionKey);

    const itemIsInOrder = Boolean(
        selectedItems &&
            selectionKey in selectedItems &&
            selectedItems?.[selectionKey]?.orderItemId,
    );

    /** Order line id when on the order; otherwise same as `selectionKey` (`getItemUid`). */
    const idToEdit = itemIsInOrder
        ? selectedItems?.[selectionKey]?.orderItemId ?? selectionKey
        : selectionKey;

    return { idToEdit, itemIsInOrder, qty, isActive };
};
